import { FreebiesMappingConsumptionService } from '@gtpl/shared-services/canteen-management';
import { ApplicationExceptionHandler } from '@gtpl/shared-utils/error-messages';
// import { FreebiesMappingConsumptionService } from '@gtpl/shared-services/canteen-management';
import { Module } from '@nestjs/common';
import { TypeOrmModule } from '@nestjs/typeorm';
import { FreebiesAdapter } from './freebies.adapter';
import { FreebiesController } from './freebies.controller';
import { FreebiesServices } from './freebies.service';
import { FreebieRepo } from './repository/freebies.repository';

@Module({
  imports: [
    TypeOrmModule.forFeature([
      FreebieRepo
    ])
  ],
  controllers: [FreebiesController],
  providers: [FreebiesServices, FreebiesAdapter, ApplicationExceptionHandler,FreebiesMappingConsumptionService
  ],
  exports: [FreebiesServices]
})
export class FreebiesModule { }



